// 公开的 /terms、/privacy 页面（正文由管理员在后台「协议设置」维护）
import React from 'react';
import { Card, Empty } from 'antd';
import { useQuery } from 'react-query';
import api from '../services/api';
import { LegalText } from '../components/TermsModal';
import { useTranslation } from 'react-i18next';

const Legal = ({ kind }) => {
  const { data, isLoading } = useQuery('legal', () => api.get('/legal').then((r) => r.data));
  const { t } = useTranslation('common');
  const title = kind === 'privacy' ? t('legal.privacy') : t('legal.terms');
  const text = data && (kind === 'privacy' ? data.privacy : data.terms);
  return (
    <div style={{ padding: 24, maxWidth: 800, margin: '0 auto' }}>
      <Card title={data?.version ? t('legal.titleWithVersion', { title, version: data.version }) : title} loading={isLoading}>
        {text ? <LegalText text={text} /> : <Empty description={t('legal.unpublished')} />}
      </Card>
    </div>
  );
};

export default Legal;
